export { default } from './StuiPagination'
